"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Divider = void 0;
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const react_1 = __importDefault(require("react"));
function Divider(props) {
    const { style = {}, vertical = false, color = lib_palette_1.default.BorderGrey } = props;
    return (react_1.default.createElement("hr", { style: Object.assign(Object.assign({}, (vertical
            ? {
                height: '100%',
                borderHeight: 0,
                borderLeft: '1px solid ' + color.main,
            }
            : {
                width: '100%',
                borderWidth: 0,
                borderTop: '1px solid ' + color.main,
            })), style) }));
}
exports.Divider = Divider;
exports.default = Divider;
